import { render, staticRenderFns } from "./customer-list-grid.vue?vue&type=template&id=043664dc"
import script from "./customer-list-grid.vue?vue&type=script&lang=js"
export * from "./customer-list-grid.vue?vue&type=script&lang=js"
import style0 from "./customer-list-grid.vue?vue&type=style&index=0&id=043664dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports